/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calculating_Timecodes_WaitInputs */



/**
* | output |
* | --- |
* | "Calculating timecodes of events... please wait..." |
*
* @param {Calculating_Timecodes_WaitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const calculating_timecodes_wait = /** @type {((inputs?: Calculating_Timecodes_WaitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calculating_Timecodes_WaitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Calcul des codes temporels des événements... veuillez patienter...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitcodes der Ereignisse werden berechnet... Bitte warten...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Calcolo dei codici temporali degli eventi... attendere prego...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вычисление временных кодов событий... пожалуйста, подождите...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Calculando códigos de tiempo de eventos... por favor espere...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在计算事件时间码……请稍候……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントのタイムコードを計算しています...お待ちください...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घटनाओं के टाइमकोड की गणना की जा रही है... कृपया प्रतीक्षा करें...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Calculando os códigos de tempo dos eventos... aguarde...")
	return /** @type {LocalizedString} */ ("Calculating timecodes of events... please wait...")
});